import { MoneyDirection } from "@common/constants";

export interface DirectionRadioDef {
    id: string;
    label: string;
    direction?: MoneyDirection;
}

export const cashDirectionRadios: DirectionRadioDef[] = [
    {
        id: "transactions-filter-form__direction__any",
        label: "Any",
        direction: undefined,
    },
    {
        id: "transactions-filter-form__direction__money_in",
        label: "Money in (e.g. deposits, refunds)",
        direction: MoneyDirection.MONEY_IN,
    },
    {
        id: "transactions-filter-form__direction__money_out",
        label: "Money out (e.g. purchases, charges)",
        direction: MoneyDirection.MONEY_OUT,
    },
];

export const glDirectionRadios: DirectionRadioDef[] = [
    {
        id: "transactions-filter-form__gl-direction__any",
        label: "Any",
        direction: undefined,
    },
    {
        id: "transactions-filter-form__gl-direction__credit",
        label: "Credit",
        direction: MoneyDirection.MONEY_IN,
    },
    {
        id: "transactions-filter-form__gl-direction__debit",
        label: "Debit",
        direction: MoneyDirection.MONEY_OUT,
    },
];
